/*
 * Sliders on homepage
 */

import { lory } from 'lory.js';

export default (($) => {
    $('.js_slider').each(function() {
        const $container = $(this);
        const slideCount = $container.find('.js_slide').length;
        const $dotContainer = $container.find('.js_dots');
        let slider;
        let $dots = [];

        // Create dots
        if ($dotContainer.length) {
            this.addEventListener('before.lory.init', () => {
                let dotHtml = '';
                for (let i = 0, len = slideCount; i < len; i++) {
                    dotHtml += '<li/>';
                }
                $dots = $(dotHtml);
                $dotContainer.append($dots);
                $dots.first().addClass('active');
            });

            this.addEventListener('after.lory.init', () => {
                $dotContainer.on('click', 'li', (event) => {
                    slider.slideTo($dots.index(event.target));
                });
            });

            this.addEventListener('after.lory.slide', (event) => {
                $dots.removeClass('active');
                $dots.eq(event.detail.currentSlide - 1).addClass('active');
            });

            this.addEventListener('on.lory.resize', () => {
                $dots.removeClass('active');
                $dots.first().addClass('active');
            });
        }

        // Initialze Lory.js
        slider = lory(this, {
            infinite: 1,
            enableMouseEvents: true,
            slideSpeed: 500,
        });

        // Auto rotate
        if ($(this).hasClass('js_slider--timer')) {
            const delay = 5000;
            setInterval(() => {
                slider.next();
            }, delay);
        }
    });
})(window.jQuery);
